import { render, staticRenderFns } from "./PapersPreview.vue?vue&type=template&id=56d1dd20&scoped=true"
import script from "./PapersPreview.vue?vue&type=script&lang=js"
export * from "./PapersPreview.vue?vue&type=script&lang=js"
import style0 from "./PapersPreview.vue?vue&type=style&index=0&id=56d1dd20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1dd20",
  null
  
)

export default component.exports